<template>
    <v-container fluid :style="$vuetify.breakpoint.name === 'xs' ? 'margin: 40px 5%' : 'margin: 60px 20%'">
      <vueHeadful
      :title="this.$i18n.t('Menu.Regalo') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
          <v-form ref="form" v-model="valido" style="width:-webkit-fill-available!important;">
            <v-col cols="12" align="center"  style="margin-bottom:60px">
                <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.Regalo')}}</h1>
            </v-col>
            <v-col cols="12" align="center">
              <p class="vietnam headline">{{$t('Regalo.Descripcion')}}</p>
            </v-col>
            <v-col cols="12" align="center">
              <p class="vietnam headline">{{$t('Regalo.Instrucciones')}}</p>
            </v-col>
            <v-col cols="12" align="center">
              <v-radio-group v-model="card" row v-if="disenos">
                <v-col cols="12" xs="12" sm="4" align="center">
                  <v-img :src="disenos.card1" width="100%" />
                  <v-radio style="justify-content:center;" color="primary" class="mx-0"></v-radio>
                </v-col>
                <v-col cols="12" xs="12" sm="4" align="center">
                  <v-img :src="disenos.card2" width="100%" />
                  <v-radio style="justify-content:center;" color="primary" class="mx-0"></v-radio>
                </v-col>
                <v-col cols="12" xs="12" sm="4" align="center">
                  <v-img :src="disenos.card3" width="100%" />
                  <v-radio style="justify-content:center;" color="primary" class="mx-0"></v-radio>
                </v-col>
              </v-radio-group>
            </v-col>
            <v-col cols="12" align="center" style="padding-top:20px">
              <h2>{{$t('Oficina.Valor')}} ({{getMoneda}})</h2>
              <v-radio-group style="justify-content:center;" v-model="cantidad" row v-if="getMoneda === 'COP'" :rules="[v => !!v || $t('Regalo.ValorRequerido')]">
                <v-radio color="primary" v-for="i in cantidadesCOP" :key="i" :value="i" :label="i.toLocaleString()"></v-radio>
                <v-radio color="primary" key="otro" value="otro" :label="$t('Oficina.OtroValor')"> </v-radio>
              </v-radio-group>
              <v-radio-group style="justify-content:center;" v-model="cantidad" row v-else :rules="[v => !!v || $t('Regalo.ValorRequerido')]">
                <v-radio color="primary" v-for="i in cantidadesUSD" :key="i" :value="i" :label="i.toLocaleString()"></v-radio>
                <v-radio color="primary" key="otro" value="otro" :label="$t('Oficina.OtroValor')"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" align="center" v-if="cantidad === 'otro'">
              <v-text-field v-model="otraCantidad" solo :label="$t('Regalo.OtraCantidad')" persistent-hint :rules="[v => !!v || $t('Regalo.ValorRequerido')]" />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="regalo.comprador" solo :label="$t('Regalo.De')" :hint="$t('Regalo.De')" persistent-hint :rules="[v => !!v || $t('Regalo.NombreRequerido')]" />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="regalo.nombre" solo :label="$t('Regalo.Para')" :hint="$t('Regalo.Para')" persistent-hint :rules="[v => !!v || $t('Regalo.NombreRequerido')]" />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="regalo.correo" solo :label="$t('Regalo.CorreoRecibe')" :hint="$t('Regalo.CorreoRecibe')" persistent-hint :rules="[v => !!v || $t('Regalo.CorreoRequerido')]" />
            </v-col>
            <v-col cols="12">
              <v-select v-model="regalo.idioma" :items="getIdiomas" item-value="id" item-text="titulo" solo :label="$t('Regalo.IdiomaRecibe')" :hint="$t('Regalo.IdiomaRecibe')" persistent-hint :rules="[v => !!v || $t('Regalo.IdiomaRequerido')]"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="regalo.mensaje" solo :label="$t('Regalo.Mensaje')" :hint="$t('Regalo.Mensaje')" persistent-hint :rules="[v => !!v || $t('Regalo.ValorRequerido')]"/>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn color="black white--text" x-large style="min-width:20%!important" @click="pagar()" :disabled="!valido">{{$t('Formularios.Pagar')}}</v-btn>
            </v-col>
          </v-form>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import logo from '../../assets/TrArtist.png'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Regalo',
  mounted () {
    firebase.firestore().collection('utilidades').doc('giftcard').get().then(info => {
      this.disenos = info.data()
    })
    this.regalo.comprador = this.getUsuario.nombre
  },
  data () {
    return {
      logo,
      valido: false,
      disenos: null,
      card: 0,
      cantidadesCOP: [100000, 200000, 500000, 1000000, 2000000],
      cantidadesUSD: [30, 50, 100, 200, 500, 1000, 2000],
      cantidad: 0,
      otraCantidad: null,
      mensaje: '',
      regalo: {
        comprador: null,
        nombre: null,
        correo: null,
        idioma: null,
        mensaje: null,
        valor: null,
        moneda: null
      }
    }
  },
  methods: {
    ...mapActions(['anadirCarrito']),
    pagar () {
      let info = {
        tipo: 'giftcard',
        producto: {
          titulo: 'GiftCard',
          cantidad: 1,
          tipo: 'giftcard',
          regalo: {
            comprador: this.regalo.comprador,
            nombre: this.regalo.nombre,
            correo: this.regalo.correo,
            idioma: this.regalo.idioma,
            mensaje: this.regalo.mensaje
          }
        }
      }
      info.producto.regalo.moneda = this.getMoneda
      if (this.getMoneda === 'COP') {
        if (this.otraCantidad) {
          info.producto.precio = this.otraCantidad
          info.producto.regalo.valor = this.otraCantidad
        } else {
          info.producto.precio = this.cantidad
          info.producto.regalo.valor = this.cantidad
        }
      } else if (this.getMoneda === 'USD') {
        if (this.otraCantidad) {
          info.producto.precio = this.otraCantidad * this.getDolar
          info.producto.regalo.valor = this.otraCantidad
        } else {
          info.producto.precio = this.cantidad * this.getDolar
          info.producto.regalo.valor = this.cantidad
        }
      }
      switch (this.card) {
        case 0:
          info.producto.imagenPrincipal = this.disenos.card1
          break
        case 1:
          info.producto.imagenPrincipal = this.disenos.card2
          break
        case 2:
          info.producto.imagenPrincipal = this.disenos.card3
          break
      }
      // console.log('Regalo Env: ', info)
      this.anadirCarrito(info)
      this.cantidad = 0
      this.otraCantidad = null
      this.regalo.nombre = null
      this.regalo.correo = null
      this.regalo.idioma = null
      this.regalo.mensaje = null
    }
  },
  computed: {
    ...mapGetters(['getMoneda', 'getIdiomas', 'getMoneda', 'getUsuario', 'getDolar']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>

<style>
.v-radio {
  margin: 16px 16px 0 0;
}
.linea {
  word-break:break-word!important;
}
</style>
